<template>
  <div class="modal-delete">
    <div class="d-flex justify-content-center flex-column align-items-center py-4">
      <img
        width="84"
        height="84"
        src="@/assets/illustration/trash-illustration.svg"
        alt="trash-illustration"
        class="mb-3"
      >
      <p class="title">Are you sure to <span>delete</span> ?</p>
      <p class="data-name"> {{ dataSelected.name }} </p>
      <div class="d-flex justify-content-center">
        <b-button
          class="btn button-modal-delete m__r--5"
          @click="$emit('close')"
        >
          Cancel
        </b-button>
        <b-button
          class="btn button-modal-delete red"
          @click="$emit('delete')"
        >
          Yes
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSelected: {
      type: Object,
      default: () => null,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popup/jPopupDelete.vue